import React from 'react';

import {
  useInterestsState,
  useInterestsActions,
} from './InterestsContext';

import {
  recognizeInterest,
  disallowInterest,
  associateInterestWithAuthenticatedUser,
  disassociateInterestWithAuthenticatedUser,
} from './restApi';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';

const InterestsTable = () => {
  const state = useInterestsState();
  const { onResponse, onError } = useInterestsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Claimed By You</Th>
          <Th>State</Th>
          <Th />
        </Tr>
      </Thead>
      <Tbody>
        {state?.interests?.map(interest => (
          <Tr key={interest.id}>
            <Td>{interest.name}</Td>
            <Td>{interest.claimedByAuthenticatedUser ? 'Yes' : 'No'}</Td>
            <Td>{interest.state}</Td>
            <Td>
              <ActionRow align="end">
                {interest.claimedByAuthenticatedUser ? (
                  <Button
                    onClick={() => {
                      disassociateInterestWithAuthenticatedUser({
                        body: {
                          interestId: interest.id,
                          pageNumber: state?.pageNumber,
                          authenticityToken,
                        },
                        onResponse,
                        onError,
                      });
                    }}
                  >
                    Unclaim
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      associateInterestWithAuthenticatedUser({
                        body: {
                          interestId: interest.id,
                          pageNumber: state?.pageNumber,
                          authenticityToken,
                        },
                        onResponse,
                        onError,
                      });
                    }}
                  >
                    Claim
                  </Button>
                )}
                {state?.authenticatedUser?.canAdministerInterests && (
                  <>
                    <Button
                      onClick={() => {
                        recognizeInterest({
                          onResponse,
                          onError,
                          body: {
                            interestId: interest.id,
                            pageNumber: state?.pageNumber,
                            authenticityToken,
                          },
                        });
                      }}
                    >
                      Recognize
                    </Button>
                    <Button
                      onClick={() => {
                        disallowInterest({
                          onResponse,
                          onError,
                          body: {
                            interestId: interest.id,
                            pageNumber: state?.pageNumber,
                            authenticityToken,
                          },
                        });
                      }}
                    >
                      Disallow
                    </Button>
                  </>
                )}
              </ActionRow>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default InterestsTable;
